import React, {useEffect} from "react";
import {Card, Tabs} from "antd";
import {ProfileTwoTone} from "@ant-design/icons";
import CustomerBillList from "./CustomerBillList";
import CustomerAccountList from "./CustomerAccountList";
import CustomerRechargeList from "./CustomerRechargeList"
import {useModel} from "../../../models"
import BalanceList from "./balance/BalanceList";

const Title = () => {
    const [{accountTotal, selectedCustomerRow}, {}] = useModel('customerBill')
    return (
        <div style={{display: "flex"}}>
            <h3 style={{flex: "1"}}>
                <ProfileTwoTone/>

                <span
                    className="margin-left-8">
                    {selectedCustomerRow ? selectedCustomerRow.customerName : ""}
                </span>
                <span
                    className="margin-left-16 color-green"
                >
                    可用额度 {accountTotal ? accountTotal.availableCreditTotal : "0.00"}</span>
                <span
                    className="margin-left-16 color-red"
                >
                    欠款 {accountTotal ? accountTotal.arrears : "0.00"}
                </span>
            </h3>
        </div>
    )
}
export default function () {
    let [{tabsKey}, {setTabsKey}] = useModel("customerBill")
    const TabPane = [
        {key: "resizeLimit", name: "调额记录"},
        {key: "recharge", name: "充值记录"},
        {key: "transferAccounts", name: "转账记录"},
    ]
    useEffect(() => {
        setTabsKey(tabsKey)
    }, [])
    const onChange = (active) => {
        // console.log(active,"////////////////")
        // debugger
        setTabsKey(active)
    }
    return (
        <Card
            title={<Title/>}
            bordered={true}
            className="margin-top-8"
        >
            <Tabs
                tabPosition="top"
                onChange={onChange}
                activeKey={tabsKey}
            >
                <Tabs.TabPane tab="账户信息" key="account">
                    <CustomerAccountList/>
                </Tabs.TabPane>
                {
                    TabPane.map(item => {
                        return (
                            <Tabs.TabPane tab={item.name} key={item.key}>
                                <CustomerRechargeList name={item.key}/>
                            </Tabs.TabPane>
                        )
                    })
                }
                <Tabs.TabPane tab="账单信息" key="putBill">
                    <CustomerBillList/>
                </Tabs.TabPane>
                {/* <Tabs.TabPane tab="平帐记录" key="balanceList">
                    <BalanceList/>
                </Tabs.TabPane> */}
            </Tabs>
        </Card>
    )
}